const pt = {
  common: {
    // Indicador global de datos simulados (MockDataBadge). Ver docs/contexto/decisiones.md D-8.
    mockData: 'Dados de demonstração',
    mockDataHint: 'O serviço de Reconhecimento ainda não está implementado: este ecrã está a ser servido com dados simulados dentro da própria aplicação.',
    loading: 'A carregar...',
    error: 'Erro',
    documentNotAvailable: 'Este documento não está disponível de momento. Pode depender do seu idioma ou da sua unidade; contacte o seu administrador se o problema persistir.',
    sessionExpiredMessage: 'A sessão expirou. Guarde o que puder e inicie sessão novamente.',
    reload: 'Iniciar sessão',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    close: 'Fechar',
    download: 'Transferir',
    confirm: 'Confirmar',
    search: 'Procurar',
    filter: 'Filtrar',
    export: 'Exportar',
    yes: 'Sim',
    no: 'Não',
    back: 'Voltar',
    next: 'Próximo',
    submit: 'Enviar',
    darkMode: 'Modo escuro',
    lightMode: 'Modo claro',
    languageMenuTitle: 'Mudar idioma',
    logout: 'Terminar sessão',
    pagerShow: 'Mostrar',
    pagerPerPage: 'por página',
    pagerOf: 'de',
    viewCards: 'Vista em cartões',
    viewList: 'Vista em lista',
    collapse: 'Recolher',
    expand: 'Expandir',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
    retry: 'Tentar novamente',
    errorBoundaryTitle: 'Algo correu mal',
    errorGeneric: 'Ocorreu um erro inesperado. Tente novamente, por favor.',
    expandModal: 'Expandir em modal',
    resetToGlobal: 'Repor para global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Início',
    growth: 'Crescimento',
    admin: 'Administração',
    executive: 'Executivo',
    analytics: 'Analytics',
    switchDemoProfile: 'Alternar perfil de demonstração',
    mobileNav: 'Navegação principal',
    fundamentals: 'Fundamentos',
    usersAdmin: 'Administradores',
    recognitionSection: 'Reconhecimentos',
    language: 'Idioma',
    collapseMenu: 'Recolher menu',
    expandMenu: 'Expandir menu',
  },
  roles: {
    employee: 'Funcionário',
    adminOU: 'Admin UA Pulso',
    adminGlobal: 'Admin Geral',
    adminPulso: 'Admin Pulso',
    adminBrillamos: 'Admin Brillamos',
    adminOUBrillamos: 'Admin UA Brillamos',
  },
  access: {
    noPlatformTitle: 'Não tem acesso à plataforma de cultura',
    noPlatformDesc: 'A sua conta não tem acesso a nenhum módulo da plataforma. Se achar que isto é um erro, entre em contacto com a sua equipa de Capital Humano.',
    profileErrorTitle: 'Não foi possível carregar o seu perfil',
    profileErrorDesc: 'Ocorreu um problema ao verificar o seu acesso. Tente novamente dentro de momentos; se o problema persistir, entre em contacto com a sua equipa de Capital Humano.',
  },
  // Pantalla «plataforma no disponible» (ServiceUnavailableView). Mismo texto que public/broadcast.html.
  serviceUnavailable: {
    label: 'Estado do serviço',
    title: 'A plataforma não está disponível',
    message: 'Estamos a trabalhar para restabelecer o serviço. Tente novamente dentro de alguns minutos.',
    retry: 'Tentar novamente',
    changeLanguage: 'Mudar idioma',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Inquéritos pendentes',
    pending: 'Pendente',
    completed: 'Concluído',
    expired: 'Expirado',
    submit: 'Enviar avaliação',
    skip: 'Saltar',
    noObs: 'Sem observação',
    meeting: 'Reunião',
    duration: 'Duração',
    participants: 'Participantes',
    simulateMeeting: 'Simular fim de reunião',
    thankYou: 'Obrigado pela sua avaliação!',
    evaluating: 'A avaliar',
    of: 'de',
    question: 'Pergunta',
    selectResponse: 'Selecione uma resposta',
    nps: {
      question: 'Qual a probabilidade de recomendar trabalhar com esta pessoa?',
      detractor: 'Detrator',
      passive: 'Passivo',
      promoter: 'Promotor',
    },
    evaluateNow: 'Avaliar agora',
    postpone: 'Depois',
    expires: 'Expira',
    noSurveysPending: 'Sem inquéritos pendentes! Bom trabalho.',
    weekCompleted: 'sem.',
    likert: {
      always: 'Sempre',
      usually: 'Quase sempre',
      sometimes: 'Às vezes',
      rarely: 'Quase nunca',
      notObservable: 'Não observável',
    },
    questions: {
      listenedActivelyText: 'Esta pessoa ouviu ativamente e demonstrou interesse genuíno?',
      sharedKnowledgeText: 'Partilhou conhecimento ou experiências relevantes durante a sessão?',
    },
    completeSubtitle: 'Seu feedback ajuda a fortalecer a cultura da equipa.',
    backToHome: 'Voltar ao início',
    greetingMorning: 'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening: 'Boa noite',
    pendingCountPre: 'Tem',
    pendingCountSingular: 'inquérito pendente',
    pendingCountPlural: 'inquéritos pendentes',
    allDoneTitle: 'Tudo em dia!',
    allDoneSubtitle: 'Não tem inquéritos pendentes. Aparecerão aqui após a sua próxima reunião.',
    omit: 'Omitir',
    omitSurvey: 'Omitir inquérito',
    submitSuccess: 'Respostas enviadas',
    submitError: 'Erro ao enviar — tente novamente',
    omitSuccess: 'Inquérito omitido',
    omitError: 'Erro ao omitir — tente novamente',
    unavailableError: 'Este inquérito já não está disponível',
    kpi: {
      answered: 'Respondidas',
      omitted: 'Omitidas',
      streak: 'Sequência',
      participation: 'Participação',
    },
    growth: {
      title: 'Seu crescimento espera por si',
      message: 'Revise seus resultados, tendências e áreas de desenvolvimento no painel de crescimento.',
      cta: 'Ver meu crescimento',
    },
    recognition: {
      title: 'Brilhamos Juntos',
      message: 'Reconheça seus colegas e celebre suas conquistas no Programa de Reconhecimento.',
      cta: 'Ir para Reconhecimento',
    },
    tips: {
      title: 'Dicas para si',
      based: 'Baseadas na sua pontuação média',
      empty: 'Complete mais inquéritos para ver dicas personalizadas',
      reconocer: 'Para reconhecer',
      crecer: 'Para crescer',
      tipOfDay: 'Dica do dia',
    },
  },
  safe: {
    title: 'Meu Crescimento',
    subtitle: 'Seu desenvolvimento cultural na Sigma',
    sectionName: 'Meu feedback',
    surveysAnswered: 'Inquéritos respondidos',
    score: 'Sua Pontuação',
    evolution: 'Sua evolução',
    evolutionSub: 'Sua jornada pessoal — só sua, sem comparações',
    radarTitle: 'Seu perfil por Fundamental',
    radarSub: 'Hoje vs há 3 meses',
    fundamentals: 'Fundamentos',
    fundamentalsChart: 'Seu feedback por Fundamental',
    fundamentalsChartSub: 'Onde está em cada um — clique em qualquer barra para detalhe',
    behaviors: 'Comportamentos',
    kudos: 'Reconhecimentos',
    kudosTitle: 'Para Reconhecer — o que mais traz',
    kudosSub: 'O que seus colegas mais observam em si este mês',
    actions: 'Plano de ação',
    omissions: 'Omissões',
    period: 'Período',
    received: 'Recebidas',
    sent: 'Enviadas',
    areaAverage: 'Média da área',
    today: 'Hoje (últimos {{days}} dias)',
    threeMonthsAgo: 'Há 3 meses (janela de {{days}} dias)',
    detail: 'Detalhe',
    profileTitle: 'Seu perfil cultural em palavras',
    profileSub: 'Comportamentos, não números',
    basedOn: 'Com base em {{count}} feedbacks anónimos',
    level0: 'Início',
    level1: 'Em desenvolvimento',
    level2: 'Consistente',
    level3: 'Referência',
    level0desc: 'Aguarda que outros resolvam os problemas ou removam os obstáculos.',
    level1desc: 'Tenta lidar com os obstáculos, mas desiste rapidamente ou escala prematuramente.',
    level2desc: 'Toma a iniciativa de remover obstáculos e encontrar soluções para avançar.',
    level3desc: 'Inspira outros a tomarem a iniciativa e cria um ambiente em que superar bloqueios é uma responsabilidade partilhada.',
    levelAbbr0: 'Início',
    levelAbbr1: 'Em des.',
    levelAbbr2: 'Consiste.',
    levelAbbr3: 'Referência',
    todayLabel: 'Hoje',
    pointsInMonths: 'pontos em {{n}} meses',
    monthsWithFeedback: 'meses com feedback',
    journeyLoading: 'A carregar a tua evolução…',
    journeyEmpty: 'Ainda não há histórico suficiente para desenhar a tua evolução. São necessários pelo menos dois meses com feedback.',
    journeyChartLabel: 'Evolução da sua média mês a mês',
    thisMonth: 'este mês',
    headingToLevel: 'Rumo a {{level}}',
    maxLevel: 'Nível máximo!',
    narrativeStrength: 'O que mais contribui e merece reconhecimento é <strong>{{fund}}</strong> — está no nível <strong>{{level}}</strong>.',
    narrativeConsistency: 'Também demonstra consistência em {{others}}.',
    narrativeProgress: 'Nos últimos 3 meses avançou — seu perfil mostra crescimento.',
    narrativeStable: 'Seu perfil manteve-se estável nos últimos 3 meses — isso fala de consistência.',
    narrativeVariation: 'Seu perfil variou um pouco nos últimos meses. Variações são normais e não definem quem se é.',
    narrativeNextLevel: 'Seu próximo nível de crescimento está em <strong>{{fund}}</strong>. O próximo passo é chegar ao nível {{level}} — abaixo sugerimos uma ação concreta.',
    act01: 'Reconhecimento — como os outros te veem',
    act02: 'Progresso — como evoluiu',
    act03: 'Direção — seu próximo passo',
    reinforces: 'REFORÇA',
    tryToday: 'Vou tentar hoje',
    committed: 'Estou comprometido hoje!',
    defaultChallenge: 'Pratique um fundamental hoje',
    defaultChallengeDesc: 'Escolha uma micro-ação e coloque em prática na sua próxima reunião.',
    clickDetail: 'Clique para detalhe',
    nextLevel: 'PRÓXIMO NÍVEL',
    growthTitle: 'PARA CONTINUAR CRESCENDO',
    growthSub: 'Recomendações baseadas no seu feedback',
    feedbacks: 'feedbacks',
    peers: 'colegas',
    givenTitle: 'Minha participação dando feedback',
    givenSub: 'Feedback que partilhou este mês',
    footerPrivacy: 'Todo o feedback é anónimo. Ninguém pode ver quem te deu. Esta visualização é só sua.',
    footerHeart: 'Lembre-se: feedback é um presente. Esses dados refletem momentos em reuniões, não quem se é.',
    personSingular: 'pessoa',
    personsPlural: 'pessoas',
    trend: {
      up: 'Seu perfil mostra crescimento',
      down: 'Pequena variação — isso é normal',
      stable: 'Perfil estável — isso é consistência',
    },
    empty: {
      title: 'Conheça os Fundamentals',
      desc: 'Ainda não tem feedback suficiente para mostrar o seu painel. Entretanto, explore os comportamentos que medimos.',
      hint: 'Seu painel é ativado quando tiver respondido mais de 3 inquéritos e recebido pelo menos 3 avaliações dos seus colegas.',
      answeredLabel: 'Inquéritos que respondeu',
      receivedLabel: 'Avaliações que recebeu',
    },
    error: {
      title: 'Não conseguimos carregar seu painel',
      desc: 'Houve um problema ao obter as suas informações. Tente novamente; se persistir, avise a equipa de suporte.',
      retry: 'Tentar novamente',
      retrying: 'A tentar…',
    },
    given: {
      loading: 'A carregar seu histórico…',
      empty: 'Ainda não respondeu nenhum inquérito.',
      loadError: 'Não conseguimos carregar seu histórico de inquéritos respondidos.',
      completed: 'Concluído',
      peopleCount_one: '{{count}} pessoa',
      peopleCount_other: '{{count}} pessoas',
    },
    celebration: {
      default: 'Seu jeito de trabalhar deixa marca em quem está ao seu redor.',
      learner: 'Sua curiosidade e abertura à aprendizagem inspiram quem trabalha consigo.',
      player_owner: 'Assume responsabilidade sem que ninguém peça, e isso define o ritmo da equipa.',
      psychological_safety: 'Pela forma como escuta, as pessoas sentem-se à vontade para dizer o que pensam.',
      collaborate_effectively: 'Quando colabora, o trabalho de todos avança mais depressa.',
      quality_of_work: 'Seu cuidado com os detalhes eleva o padrão do que a equipa entrega.',
      make_others_successful: 'Faz questão de que os outros brilhem, e a equipa inteira percebe.',
      explore_experiment: 'Sua disposição para experimentar abre caminhos que ninguém tinha visto.',
    },
    popup: {
      peersOpined: 'colegas avaliaram',
      evaluationsCount: '{{count}} avaliações',
      subbehaviors: 'Sub-comportamentos',
      dailyHabits: 'Hábitos diários',
      monthlyHistory: 'Evolução mensal',
      distribution: 'Distribuição de feedbacks',
      behaviorScale: 'Escala de comportamento',
      you: 'Eu',
    },
  },
  admin: {
    title: 'Administração',
    menu: {
      general: 'Admin Geral',
      pulso: 'Pulso',
      brillamos: 'Brillamos',
    },
    roleAdminGeneral: 'Admin Geral',
    roleAdminPulso: 'Admin Pulso',
    roleAdminOUPulso: 'Admin UA Pulso',
    roleAdminBrillamos: 'Admin Brillamos',
    roleAdminOUBrillamos: 'Admin UA Brillamos',
    roleEmployee: 'Funcionário',
    greetingMorning: 'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening: 'Boa noite',
    surveys: 'Inquéritos',
    templates: 'Templates',
    analyticsTab: 'Analytics',
    rulesTab: 'Regras de Negócio',
    users: 'Utilizadores',
    notifications: 'Notificações',
    surveysTitle: 'Gestão de Inquéritos',
    searchSurvey: 'Procurar inquérito...',
    trash: 'Lixeira',
    newSurvey: 'Novo Inquérito',
    fundamentalsTab: 'Fundamentos',
    customTab: 'Personalizadas',
    colName: 'Nome',
    colTitle: 'Título',
    colDescription: 'Descrição',
    colQuestions: 'Perguntas',
    colStatus: 'Estado',
    colAudience: 'Audiência',
    sectionCrashed: "Não foi possível exibir esta secção. Tente novamente ou escolha outra.",
    colFrequency: 'Frequência',
    freqDaily: 'Diária',
    freqWorkdays: 'Dias úteis',
    freqWeekly: 'Semanal · {{day}}',
    freqCustom: '{{count}} dias/semana',
    freqNone: '—',
    colFeedback: 'Feedbacks',
    colPeriod: 'Período',
    colActions: 'Ações',
    colCreatedBy: 'Criada por',
    creatorUnknown: 'Desconhecido',
    colEmail: 'Email',
    colOU: 'UA',
    colUses: 'usos',
    statusActive: 'Ativo',
    statusPaused: 'Pausado',
    statusInactive: 'Inativo',
    statusPending: 'Pendente',
    anonymous: 'Anónimo',
    duplicate: 'Duplicar',
    exportExcelTip: 'Exportar Excel',
    templatesTitle: 'Templates de Inquéritos',
    tipsTab: 'Dicas',
    actionsTab: 'Ações',
    catalogTab: 'Catálogos',
    createTemplate: 'Criar template',
    typeFundamental: 'Fundamental',
    typeCustom: 'Personalizada',
    placeholderTips: 'Dicas — Módulo de conselhos para colaboradores',
    tplSearchPlaceholder: 'Procurar template…',
    tplFilterAll: 'Todos os tipos',
    tplNoResults: 'Nenhum template com esse critério',
    tipsTitle: 'Dicas de Feedback',
    tipsSearchPlaceholder: 'Procurar dica…',
    tipsAllFundamentals: 'Todos os Fundamentais',
    tipsAllTypes: 'Todos os tipos',
    tipTypeReconocer: 'Para Reconhecer',
    tipTypeCrecer: 'Para Crescer',
    tipsNoResults: 'Nenhuma dica com esse critério',
    surveysNoResults: 'Nenhum inquérito com esse critério',
    surveysError: 'Erro ao carregar inquéritos. Tente novamente mais tarde.',
    createTip: 'Criar dica',
    actionsTitle: 'Ações de Crescimento',
    actionsSearchPlaceholder: 'Procurar ação…',
    actionsNoResults: 'Nenhuma ação com esse critério',
    createAction: 'Criar ação',
    catalogTitle: 'Catálogo de Fundamentais',
    catalogFundamentals: 'Fundamentais',
    catalogBehaviors: 'Comportamentos',
    catalogAddFundamental: 'Adicionar Fundamental',
    catalogAddBehavior: 'Adicionar Daily Habit',
    catalogSearchFundamental: 'Procurar fundamental…',
    catalogSearchBehavior: 'Procurar daily habit…',
    catalogNoBehaviors: 'Sem daily habits para este fundamental',
    catalogSelectFundamental: 'Selecione um Fundamental da lista',
    ousTab: 'OUs',
    ousTitle: 'Unidades Organizacionais',
    ousSubtitle: 'Gira as OUs raiz do tenant',
    ousSearchPlaceholder: 'Procurar OU…',
    ousNoResults: 'Nenhuma OU corresponde a esse critério',
    createOU: 'Criar OU',
    editOU: 'Editar OU',
    deleteOU: 'Eliminar OU',
    deleteOUConfirm: 'Eliminar OU "{{name}}"? Esta ação não pode ser desfeita.',
    ouDescription: 'Descrição',
    ouAdminUser: 'Admin OU (AAD User ID)',
    ouType: 'Tipo',
    ouGdpr: 'RGPD',
    ouAzureGroupId: 'ID do grupo do Azure AD',
    ouAzureGroupIdHint: 'Vincule esta OU ao seu grupo real no Azure AD para a árvore hierárquica. Deixe vazio se ainda não estiver provisionado.',
    ouAzureGroupIdSelectPlaceholder: '— Selecione um grupo raiz do Azure AD —',
    ouAzureGroupIdLoading: 'A carregar grupos do Azure AD…',
    ouAzureGroupIdRootsError: 'Não foi possível carregar a lista de grupos do Azure AD. Pode introduzir o ID manualmente.',
    ouAzureGroupIdCurrentUnknown: 'Grupo vinculado atual (não aparece na lista)',
    ouAzureGroupIdManualToggle: 'Introduzir o ID manualmente',
    ouAzureGroupIdListToggle: 'Escolher da lista',
    ouActivate: 'Ativar OU',
    ouDeactivate: 'Desativar OU',
    ouActivateCascadeTitle: 'Ativar OU e dependentes',
    ouActivateCascadeConfirm: 'Ao ativar "{{name}}" será ativada também toda a sua descendência (unidades dependentes afetadas: {{units}}). Poderá desativá-las individualmente depois.',
    ouDeactivateCascadeTitle: 'Desativar OU e dependentes',
    ouDeactivateCascadeConfirm: 'Ao desativar "{{name}}" será desativada também toda a sua descendência (unidades dependentes afetadas: {{units}}).',
    ouActiveSaveError: 'Não foi possível guardar a alteração de estado da OU. Tente novamente.',
    ouExpand: 'Expandir',
    ouLockedHint: "A sua unidade organizacional: não pode ser removida do alcance.",
    ouCollapse: 'Recolher',
    ouSelectPlaceholder: 'Selecionar OU…',
    ouSearchPlaceholder: 'Pesquisar OU…',
    ouSearchNoResults: 'Sem resultados.',
    ouInactiveHint: 'OU inativa: não pode ser escolhida como novo alcance.',
    ouSelectAllInLevel: 'Selecionar tudo',
    ouBackToLevels: 'Voltar ao nível anterior',
    ouErrorName: 'O nome da OU é obrigatório',
    ouTimezone: 'Fuso Horário',
    ouTimezoneSelect: 'Selecione o fuso horário',
    ouErrorTimezone: 'O fuso horário é obrigatório',
    colFundamental: 'Fundamental',
    colCondition: 'Condição',
    placeholderActions: 'Ações — Planos de ação pós-inquérito',
    placeholderCatalog: 'Catálogo de Fundamentals — Biblioteca de comportamentos avaliáveis',
    placeholderAnalytics: 'Dashboard unificado de Analytics — Ver visão Executivo para detalhes completos',
    activeUsersLabel: 'Colaboradores ativos',
    avgCulturalScore: 'Score cultural médio',
    participationRateLabel: 'Taxa de participação',
    omissionRateLabel: 'Taxa de omissão',
    thisMonth: 'este mês',
    rulesTitle: 'Regras de Negócio',
    restoreDefaults: 'Restaurar Padrões',
    restoreDefaultsTitle: 'Restaurar configuração padrão',
    restoreDefaultsDesc: 'Todos os valores das regras de negócio serão redefinidos para a configuração original. Esta ação não pode ser desfeita.',
    restoreDefaultsConfirm: 'Sim, restaurar',
    rn001Title: 'Critérios de Reunião',
    rn001Subtitle: 'Define a duração de reuniões que ativam inquérito',
    rn002Title: 'Regras de Exclusão',
    rn002Subtitle: 'Cenários onde inquéritos NÃO são disparados',
    rn004Title: 'Limites por Utilizador',
    rn004Subtitle: 'Controla a quantidade de inquéritos que cada pessoa recebe',
    rn005Title: 'Limite Diário de Inquéritos',
    rn005Subtitle: 'Número máximo de inquéritos que um utilizador pode receber por dia',
    fieldMinSessionDuration: 'Duração mínima da sessão',
    fieldMaxSessionDuration: 'Duração máxima da sessão',
    fieldMinParticipants: 'Mínimo de participantes',
    fieldMaxParticipants: 'Máximo de participantes',
    fieldExclRecurring: 'Excluir reuniões recorrentes',
    fieldExclRecurringSub: 'Não aplicar em reuniões semanais, dailies, etc.',
    fieldExclWorkHours: 'Excluir fora do horário de trabalho',
    fieldExclWorkHoursSub: 'Aplicar apenas dentro do horário configurado por UA',
    fieldMaxSurveysWeek: 'Máximo de inquéritos por semana',
    fieldMaxParticipantsPerSurvey: 'Máximo de participantes a avaliar por inquérito',
    fieldMinInterval: 'Intervalo mínimo entre inquéritos',
    fieldMaxSurveysDay: 'Máximo de inquéritos por dia por utilizador',
    rn005Info: 'Se um utilizador já recebeu o máximo de inquéritos no dia, os seguintes são adiados para o próximo dia útil respeitando a ordem de prioridade configurada.',
    suffixMinutes: 'minutos',
    suffixUsers: 'utilizadores',
    suffixSurveysWeek: 'inquéritos/semana',
    suffixPersons: 'pessoas',
    suffixHours: 'horas',
    suffixSurveysDay: 'inquéritos / dia',
    customizableByOU: 'Personalizável por UA',
    cancelChanges: 'Cancelar alterações',
    saveConfig: 'Guardar configuração',
    rulesConfig: 'Configuração',
    rulesStatus: 'Estado',
    rulesCustom: 'Personalizado',
    rulesSave: 'Guardar',
    rulesCancel: 'Cancelar',
    rulesSchedule: 'Horário',
    rulesInheritsGlobal: '↑ Herda global',
    rulesInherited: 'Herdado',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personalizar',
    tplCatAll: 'Todos',
    tplCatGeneral: 'Geral',
    tplCatCustom: 'Personalizada',
    usersTitle: 'Gestão de Utilizadores',
    searchUser: 'Procurar utilizador...',
    newUser: 'Novo utilizador',
    notificationsTitle: 'Configuração de Notificações',
    notifOmitirTitle: 'Notificação de "SALTAR"',
    notifyAfter: 'Notificar após',
    consecutiveOmissions: '"SALTAR" consecutivos',
    notifyTo: 'Notificar:',
    notifyUser: 'Utilizador',
    notifyDirectManager: 'Gerente direto',
    notifyAdminOU: 'Administrador UA',
    messageForUser: 'Mensagem para o utilizador:',
    availableVarsOmitir: 'Variáveis disponíveis: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omissões Europa (BU)',
    manualOnlyGDPR: 'Somente manual — RGPD',
    gdprWarning: 'Devido a regulamentações legais (RGPD), os e-mails de omissão para a Europa nunca são enviados automaticamente. O administrador deve redigi-los, revisá-los e enviá-los manualmente.',
    emailTemplateEmployee: 'Modelo de e-mail — funcionário Europa:',
    reviewBeforeSending: 'Revisar e personalizar antes de cada envio.',
    generalNotificationsTitle: 'Notificações Gerais',
    notifMessageLabel: 'Mensagem da notificação:',
    notifMessagePlaceholder: 'Escreva a mensagem que deseja enviar aos colaboradores...',
    notifAudienceLabel: 'Audiência:',
    notifAudienceGlobal: 'Global (excl. Europa)',
    sendNotification: 'Enviar notificação',
    availableVarsGeneral: 'Variáveis disponíveis: {nombre}, {ou}, {fecha}',
    saveChanges: 'Guardar alterações',
    saveTemplates: 'Guardar modelos',
    analyticsComingSoon: 'Painel de Analytics — em desenvolvimento. Consulte a visão Executiva para detalhes.',
    colType: 'Tipo',
    tplCategory: 'Categoria',
    tplQuestions: 'perguntas',
    tplUse: 'Usar',
    tplDeleteTitle: 'Eliminar template',
    tplDeleteDesc: 'Eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    tipDeleteTitle: 'Eliminar tip',
    tipDeleteDesc: 'Eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    tipEditTitle: 'Editar dica',
    tipAddTitle: 'Adicionar dica',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Selecione um fundamental…',
    tipFormDailyHabit: 'Daily Habit vinculado',
    tipFormSelectDailyHabit: 'Selecione um Daily Habit…',
    tipFormOperator: 'Operador',
    tipFormThreshold: 'Limiar %',
    tipFormMax: 'Máx %',
    tipFormType: 'Tipo de dica',
    tipFormName: 'Nome da dica',
    tipFormNamePlaceholder: 'Ex.: Aprendizagem em Destaque',
    tipFormText: 'Texto da dica',
    tipFormTextPlaceholder: 'Mensagem que o colaborador verá…',
    tipFormActivationRule: 'Condição de resultado',
    tipFormActive: 'Ativo',
    tipFormPreview: 'Pré-visualização',
    tipRangeMin: 'Limite mínimo',
    tipRangeMax: 'Limite máximo',
    tipHintCondition: 'Score médio do fundamental (0–100). Ex.: de 0 a 40 ativa o tip em resultados baixos.',
    tipHintBehavior: 'Comportamento específico ao qual este tip se aplica.',
    tipFieldObserved: 'Texto observado',
    tipTagGreen: 'caixa verde clara',
    tipTagDark: 'caixa escura',
    tipTagBlue: 'caixa Próximo Nível',
    tipHintObserved: 'O que os colegas observam. Aparece em itálico no painel de conquistas.',
    tipFieldGrowthSuggestion: 'Sugestão de Crescimento',
    tipHintGrowthSuggestion: 'Sugestão acionável que aparece junto ao reconhecimento.',
    tipFieldLevelName: 'Nome do nível',
    tipLevelNamePlaceholder: 'Ex. Impulso Necessário, Em Construção…',
    tipCrecerPairedPlaceholder: 'Ex. Mencione o consumidor: Na sua próxima decisão, pergunte…',
    tipTranslations: 'Traduções',
    tipAddLang: '+ Adicionar:',
    tipPreviewContext: 'É assim que aparecerá no painel do colaborador:',
    tipSave: 'Guardar tip',
    tipSaveError: 'Para guardar, preencha os seguintes campos:',
    colContent: 'Conteúdo',
    colActive: 'Ativo',
    opGte: 'maior ou igual',
    opLte: 'menor ou igual',
    opGt: 'maior que',
    opLt: 'menor que',
    opBetween: 'Entre (intervalo)',
    actionEditTitle: 'Editar ação',
    actionNewTitle: 'Nova ação',
    actionFormTitle: 'Título da ação',
    actionFormTitlePlaceholder: 'Ex. Proponha uma ação concreta',
    actionFormDescription: 'Descrição completa',
    actionFormDescPlaceholder: 'Descrição da ação…',
    actionActivationRule: 'Regra de ativação',
    actionActivationRuleHint: 'Pontuação média do fundamental (1–4). Define o intervalo que ativa esta ação.',
    actionRuleMin: 'Limite mínimo',
    actionRuleMax: 'Limite máximo',
    actionRangeLabel: 'Intervalo',
    actionNextLevelText: 'Texto "Próximo Nível"',
    actionNextLevelHint: 'Aparece na caixa azul do cartão.',
    actionNextLevelPlaceholder: 'Ex. Para chegar ao próximo nível, concentre-se em…',
    actionPreview: 'Pré-visualização',
    actionPreviewEmpty: 'Preencha o formulário para ver a pré-visualização',
    actionTranslations: 'Traduções',
    actionTransComplete: 'Tradução completa',
    actionTransMissing: 'Tradução incompleta',
    actionPreviewContext: 'Assim aparecerá no painel do colaborador:',
    actionFormDescHint: 'Exibido ao abrir a ação.',
    actionSave: 'Guardar ação',
    actionSaveError: 'Para guardar, complete os seguintes campos:',
    actionDeleteTitle: 'Eliminar ação',
    actionDeleteDesc: 'Eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    fundEditTitle: 'Editar Fundamental',
    fundNewTitle: 'Novo Fundamental',
    fundFormFullName: 'Nome completo',
    fundFormFullNamePlaceholder: 'Ex. Mindset & Behavior - Learner',
    fundFormShortName: 'Nome curto',
    fundFormShortNamePlaceholder: 'Ex. Learner',
    fundFormDescription: 'Descrição',
    fundFormDescriptionPlaceholder: 'Breve descrição deste fundamental...',
    fundFormIcon: 'Ícone',
    fundFormColor: 'Cor',
    fundFormUrl: 'URL de referência',
    fundFormMicrositeUrl: 'URL do microsite',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Idioma',
    fundFormAllLangsRequired: 'Preencha o nome completo, nome curto e descrição nos 7 idiomas para poder guardar.',
    behEditTitle: 'Editar Daily Habit',
    behNewTitle: 'Novo Daily Habit',
    behFormName: 'Nome do Daily Habit',
    behFormNamePlaceholder: 'Ex. Humility & Openness',
    behFormAllLangsRequired: 'Preencha o nome nos 7 idiomas para poder guardar.',
    behFormFundamental: 'Fundamental vinculado',
    behFormIntro: 'Introdução / contexto de avaliação',
    behFormIntroPlaceholder: 'Ex. Nesta reunião, esta pessoa…',
    behFormRoles: 'Funções aplicáveis',
    behFormRolesHint: 'A quem este Daily Habit se aplica?',
    fundDeleteTitle: 'Eliminar fundamental',
    fundDeleteDesc: 'Eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    behDeleteTitle: 'Eliminar Daily Habit',
    behDeleteDesc: 'Eliminar "{{name}}"? Esta ação não pode ser desfeita.',
    imageUploadSelect: 'Enviar imagem',
    imageUploadChange: 'Alterar imagem',
    imageUploadInvalidFormat: 'Formato não suportado. Use PNG, JPG, WEBP ou SVG.',
    imageUploadTooLarge: 'O ficheiro excede o tamanho máximo permitido (2 MB).',
    catalogSaveError: 'Não foi possível guardar as alterações do catálogo. Tente novamente.',
    catalogImageUploadError: 'Não foi possível carregar a imagem. Tente novamente.',
    fundFormImage: 'Imagem',
    attNewTitle: 'Nova Atitude e Comportamento',
    attEditTitle: 'Editar Atitude e Comportamento',
    attFormName: 'Nome da Atitude e Comportamento',
    attFormNamePlaceholder: 'Ex. Colaboração ativa',
    attFormDescription: 'Descrição da Atitude e Comportamento',
    attFormDescriptionPlaceholder: 'Breve descrição desta atitude e comportamento...',
    attFormAllLangsRequired: 'Preencha o nome nos 7 idiomas para guardar.',
    // Botón "Traducir a los demás idiomas" de los modales del catálogo de fundamentales
    catalogTranslateBtn: 'Traduzir para os restantes idiomas',
    catalogTranslating: 'A traduzir…',
    catalogTranslateHint: 'Escreva o texto em pelo menos um idioma para poder traduzir.',
    catalogTranslateErrorRetry: 'Não foi possível traduzir. Tente novamente.',
    catalogTranslateErrorWait: 'O serviço de tradução não está disponível neste momento. Aguarde um momento e tente novamente.',
    attFormImage: 'Imagem',
    attDeleteTitle: 'Eliminar Atitude e Comportamento',
    attDeleteDesc: 'Eliminar "{{name}}"? Os Daily Habits também serão desativados.',
    catalogAttitudesLabel: 'atitudes e comportamentos',
    catalogSelectAttitude: 'Selecione uma Atitude e Comportamento da lista',
    catalogBackToFundamentals: 'Voltar aos Fundamentals',
    catalogBackToAttitudes: 'Voltar às Atitudes e Comportamentos',
    catalogGroupWithAttitudes: 'Agrupar em Atitudes e Comportamentos',
    catalogNoFundamentals: 'Sem fundamentais',
    madurezEditTitle: 'Editar níveis de Maturidade Cultural',
    madurezFrameworkTitle: 'Maturidade Cultural — Estrutura de níveis',
    nivelesAdopcionTitle: 'Etapas de adoção de um Daily Habit — Estrutura de níveis',
    nivelesAdopcionEditTitle: 'Editar etapas de adoção de um Daily Habit',
    madurezLabelPlaceholder: 'Rótulo',
    audienceGlobal: 'Global (excl. Europa)',
    audienceMexico: 'México',
    audienceLATAM: 'LATAM',
    audienceUSA: 'EUA',
    audienceFOSE: 'FOSE',
    rn000Title: 'Desativar App por UO',
    rn000Subtitle: 'Desativa completamente o Sigma Pulse para uma ou mais unidades organizacionais.',
    rn000Warning: 'Ao desativar uma UO, todos os seus colaboradores param de receber inquéritos imediatamente. Os dados históricos são preservados.',
    rn003Title: 'Horário de Trabalho por UO',
    rn003Subtitle: 'Horário em que os inquéritos são aplicados (hora local)',
    rn003GlobalDefault: 'Horário global padrão',
    rn003GlobalNote: 'Aplica-se a todas as UOs sem horário personalizado.',
    rn003TimeConnector: 'às',
    ouActive: 'Ativa',
    ouDisabled: 'Desativada',
    rn002KwLabel: 'Excluir somente se o nome contém:',
    rn002KwHint: '(vazio = todas as recorrentes)',
    rn002KwPlaceholder: 'Adicionar palavra-chave...',
    usersAdminTitle: 'Gestão de Administradores',
    addAdmin: 'Adicionar Administrador',
    editAdmin: 'Editar Administrador',
    newAdmin: 'Novo Administrador',
    adminEmail: 'Endereço de e-mail',
    adminUser: 'Utilizador',
    userSearchPlaceholder: 'Procure por nome ou e-mail…',
    userSearchNoResults: 'Nenhum utilizador encontrado',
    userSearchError: 'Erro ao procurar utilizadores',
    adminRole: 'Função',
    adminRolePlaceholder: 'Selecione uma função...',
    adminOU: 'Unidade Operacional (UO)',
    adminOUPlaceholder: 'Selecione uma UO...',
    adminOUAll: 'Todas (acesso completo à UO)',
    adminBU: 'Unidade de Negócios (BU) — opcional',
    adminBUPlaceholder: 'Toda a UO (sem restrição)',
    adminBUHint: 'Se nenhuma BU for selecionada, o admin gerencia toda a UO.',
    colUser: 'Utilizador',
    colAlcance: 'Escopo',
    colPermisos: 'Permissões',
    colEstado: 'Estado',
    accountActive: 'Conta ativa (acesso à plataforma)',
    accountActiveHint: 'É a conta da pessoa, não a sua função de administrador. Desligada, não pode entrar na plataforma.',
    deactivateAccountTitle: 'Desativar a conta',
    deactivateAccountMsg: '{{name}} não poderá entrar na plataforma. Isto não retira a sua função: desativa a conta. Continuar?',
    deactivateAccountConfirm: 'Sim, desativar a conta',
    permGlobalTitle: 'Admins UO/BU podem criar inquéritos',
    permGlobalDesc: 'Quando ativo, todos os Admins UO/BU podem criar e enviar inquéritos.',
    permEnabled: 'Ativado',
    permDisabled: 'Desativado',
    permCreateSurveys: 'Criar inquéritos',
    permViewAnalytics: 'Ver Analytics',
    permManageUsers: 'Gerir Utilizadores',
    permApproveSurveys: 'Aprovar inquéritos',
    permCatalogFund: 'Catálogo de Fundamentais',
    permCatalogOus: 'Catálogo de OUs',
    // 2026-08-08 — reorganização do menu de Administração
    administratorsTab: 'Gestão de Administradores',
    catalogFundTab: 'Catálogo de Fundamentais',
    catalogOusTab: 'Catálogo de OUs',
    rolesPulsoTab: 'Configurar funções e permissões',
    rolesPulsoTitle: 'Configurar funções e permissões',
    rolesPulsoAllScopes: 'Todas',
    rolesPulsoAlreadyNote: 'Esta pessoa já é administradora do Pulso — edite os dados abaixo.',
    rolesPulsoCannotEditGlobal: 'Esta pessoa já tem o papel de Admin Geral. Esse papel não é gerido a partir daqui.',
    administratorsTitle: 'Gestão de Administradores',
    administratorsDesc: 'Adicionar ou remover administradores globais do sistema.',
    addGlobalAdmin: 'Adicionar administrador',
    newGlobalAdmin: 'Novo administrador global',
    adminGlobalRemoveTitle: 'Remover administrador global',
    adminGlobalRemoveDesc: 'Remover "{{name}}" como administrador global? A conta mantém-se como colaborador padrão.',
    userDeleteTitle: 'Remover administrador',
    userDeleteDesc: 'Remover "{{name}}" como administrador? A conta continuará ativa como colaborador padrão, sem permissões de administração.',
    userCreated: 'Utilizador criado com sucesso.',
    userSaveError: 'Não foi possível guardar as alterações. Tente novamente.',
    userSaveForbidden: 'Não tem permissão para modificar este administrador. Só um Admin Geral o pode fazer.',
    userCreateErrorNotInAd: 'Não foi possível criar o utilizador: o e-mail não existe no Azure AD.',
    userDeleteError: 'Não foi possível remover o papel de administrador. Tente novamente.',
    noUsersFound: 'Sem resultados',
    adminCount: 'administradores',
    filterEmailPlaceholder: 'Pesquisar por e-mail...',
    filterRoleLabel: 'Filtrar por função',
    filterRoleAll: 'Todas as funções',
    filterClear: 'Limpar filtros',
    rolesMultiHint: 'Pode selecionar mais de uma função mantendo pressionada a tecla Ctrl (Cmd no Mac).',
    modulesTitle: 'Módulos',
    modulesHint: 'Controla o acesso aos módulos do produto, independentemente da função atribuída.',
    modulePulso: 'Pulso',
    moduleBrillamos: 'Reconhecimento',
    permAllGranted: 'Todas concedidas',
    userNotManageable: 'Não pode gerir este utilizador',
    messageForManager: 'Mensagem para o manager:',
    emailTemplateManager: 'Modelo de e-mail — manager Europa:',
    notifOUPersonalization: 'Personalização por UO',
    addOUPersonalization: 'Adicionar personalização',
    europaNoAutoSend: 'Esses e-mails não são enviados automaticamente.',
    europaActivateTitle: 'Ativar notificações Europa?',
    europaActivateDesc: 'As notificações de omissões para a Europa estão sujeitas a regulamentos RGPD estritos. Ao ativar esta secção confirma que tem autorização do responsável de privacidade da UO Europa e que os e-mails serão enviados manualmente com revisão prévia.',
    europaActivateConfirm: 'Sim, ativar com responsabilidade',
    includeEuropa: 'Incluir Europa (BU)',
    includeEuropaHint: 'requer revisão RGPD antes do envio',
    europaSectionDisabled: 'Secção desativada — ative o switch para configurar',
    ouPersonalizedSingular: 'OU personalizada',
    ouPersonalizedPlural: 'OUs personalizadas',
    notifCustomUserMsgPlaceholder: 'Mensagem personalizada para o utilizador…',
    notifCustomMgrMsgPlaceholder: 'Mensagem personalizada para o manager…',
    kwRemove: 'Remover',
    kwAdd: 'Adicionar',
    permissions: 'Permissões',
    rules: 'Regras de negócio',
    catalog: 'Catálogo',
    createUser: 'Criar utilizador',
    editUser: 'Editar utilizador',
    deleteUser: 'Eliminar utilizador',
    roles: 'Função',
    organizationalUnit: 'Unidade Organizacional',
    minDuration: 'Duração mínima (min)',
    maxDuration: 'Duração máxima (min)',
    minParticipants: 'Participantes mínimos',
    maxPerDay: 'Máx. avaliações por dia',
    maxPerWeek: 'Máx. avaliações por semana',
    omissionThreshold: 'Limite de omissões',
    columns: 'Colunas',
    colPickerTitle: 'Colunas visíveis',
    colPickerReset: 'Redefinir',
    pagerRowsPerPage: 'Linhas por página',
    pagerOf: 'de',
    confirmMoveToTrash: 'Mover para lixeira?',
    confirmMoveToTrashMsg: 'O inquérito será movido para a lixeira e eliminado permanentemente após 30 dias. Pode restaurá-lo antes desse prazo.',
    confirmMoveBtn: 'Mover para lixeira',
    confirmDeleteForeverTitle: 'Eliminar permanentemente?',
    confirmDeleteForeverMsg: 'Esta ação é irreversível. O inquérito e todos os seus dados serão eliminados para sempre.',
    confirmDeleteForeverBtn: 'Eliminar para sempre',
    trashTitle: 'Lixeira de inquéritos',
    trashSubtitle: 'Os inquéritos são eliminados permanentemente após 30 dias',
    trashEmpty: 'A lixeira está vazia',
    trashRestore: 'Restaurar',
    trashDaysLeft: 'dias restantes',
    colSurvey: 'Inquérito',
    trashResponses: 'resp.',
    trashTimeLeft: 'Tempo restante',
    trashDeletedBy: 'Eliminado por',
    trashDeletedAt: 'Data de eliminação',
    trashDays: 'dias',
    trashExpiresTODAY: 'Expira hoje',
    filterAll: 'Todos',
    filterSearchName: 'Procurar nome…',
    filterSearchCreator: 'Procurar criador…',
    filterFrom: 'De',
    filterTo: 'Até',
    filterClearDates: 'Limpar datas',
    pauseSurvey: 'Pausar',
    activateSurvey: 'Ativar',
    builderNewTitle: 'Novo Inquérito',
    builderEditTitle: 'Editar Inquérito',
    builderNewTemplateTitle: 'Novo Template',
    builderEditTemplateTitle: 'Editar Template',
    builderBackToSurveys: 'Voltar aos inquéritos',
    builderSaveDraft: 'Guardar rascunho',
    builderPublish: 'Publicar inquérito',
    builderStep1: 'Informações Básicas',
    builderStep2: 'Audiência e Frequência',
    builderStep3: 'Perguntas',
    builderStep4: 'Revisão',
    builderPreview: 'Pré-visualização',
    builderName: 'Nome do inquérito',
    builderNamePlaceholder: 'Ex.: Avaliação Pós-Reunião Q2',
    builderDescription: 'Descrição',
    builderDescriptionPlaceholder: 'Descreva o propósito deste inquérito…',
    builderApproach: 'Abordagem',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Coletivo',
    builderAnonymous: 'Avaliação anónima',
    builderAnonymousSub: 'Os avaliados não saberão quem os avaliou',
    dayMon: 'Segunda-feira', dayTue: 'Terça-feira', dayWed: 'Quarta-feira', dayThu: 'Quinta-feira',
    dayFri: 'Sexta-feira', daySat: 'Sábado', daySun: 'Domingo',
    dayMonShort: 'Seg', dayTueShort: 'Ter', dayWedShort: 'Qua', dayThuShort: 'Qui',
    dayFriShort: 'Sex', daySatShort: 'Sáb', daySunShort: 'Dom',
    dayLetterMon: 'S', dayLetterTue: 'T', dayLetterWed: 'Q', dayLetterThu: 'Q',
    dayLetterFri: 'S', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'O inquérito estará ativo a semana toda',
    activeDaysPrefix: 'O inquérito estará ativo em:',
    activeDaysNone: 'Nenhum dia selecionado',
    workdays: 'Dias úteis',
    builderExitTitle: 'Sair do editor?',
    builderExitDesc: 'As alterações não guardadas serão perdidas se sair agora.',
    builderExitCancel: 'Continuar editando',
    builderExitConfirm: 'Sim, sair',
    builderValidationTitle: 'Campos obrigatórios',
    builderValidationDesc: 'Por favor preencha os seguintes campos antes de continuar:',
    builderValidationClose: 'Entendido',
    builderValidationName: 'Identificador Interno',
    builderValidationSurveyType: 'Tipo de inquérito',
    builderValidationStartDate: 'Data de início',
    builderValidationEndDate: 'Data de término',
    builderValidationDateRange: 'A data de término não pode ser anterior à data de início',
    builderValidationActiveDays: 'Pelo menos um dia de ativação',
    builderValidationStartDatePast: 'A data de início já passou; o inquérito nunca seria publicado',
    builderValidationEndDatePast: 'A data de término já passou; o inquérito nunca seria publicado',
    builderValidationMeetingId: 'Informe o ID do Meeting',
    builderValidationPeople: 'Selecione pelo menos uma pessoa',
    builderValidationOU: 'Selecione pelo menos uma OU',
    builderValidationNoQuestions: 'Deve adicionar pelo menos uma pergunta para continuar. Não é possível criar inquéritos sem perguntas.',
    builderValidationMinParticipants: 'O mínimo de participantes deve ser pelo menos 1',
    builderValidationMaxParticipants: 'O máximo de participantes deve ser pelo menos 1',
    builderValidationParticipantsRange: 'O mínimo de participantes não pode ser maior que o máximo',
    builderValidationTranslations: 'Traduções incompletas',
    // Builder new keys
    builderCloseEditor: 'Fechar editor',
    builderPrevious: 'Anterior',
    builderNext: 'Próximo',
    builderSaveTemplate: 'Guardar como template',
    builderInternalId: 'Identificador interno',
    builderInternalIdHint: 'Visível apenas para administradores — os colaboradores não veem este nome ao responder',
    builderSurveyTypeStar: 'Tipo de inquérito',
    builderTypeGeneral: 'Geral',
    builderTypeGeneralDesc: 'Regido por regras de negócio. Disparado automaticamente após reuniões.',
    builderTypePersonalized: 'Personalizada',
    builderTypePersonalizedDesc: 'Vinculada a uma sessão específica do Teams por Meeting ID.',
    builderPeriod: 'Período do inquérito',
    builderStartLabel: 'Início',
    builderEndLabel: 'Fim',
    builderPeriodHint: 'O inquérito será ativado na data de início e desativado automaticamente ao terminar',
    builderActiveDaysLabel: 'Dias de ativação',
    builderActiveDaysLockedHint: 'O dia é definido automaticamente porque o intervalo de datas é de um único dia',
    builderCustomTag: 'Personalizado',
    builderAudienceSectionTitle: 'Audiência',
    builderWhoApplies: 'A quem se aplica este inquérito?',
    builderSelectOneOrMoreOUs: 'Selecione uma ou mais UAs',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Todas as UAs e BUs',
    builderExcludesEurope: 'exclui Europa',
    builderGlobalAdminOUAccess: 'Administrador Global — tem acesso a todas as UAs do sistema.',
    builderLegalRegulation: 'Regulação legal — sempre campo separado',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'RGPD — Regulação legal',
    builderEuropeExcludedNote: 'A Europa nunca é incluída em campanhas Globais nem multi-UA por cumprimento legal.',
    builderEuropaAuthNote: 'Lembre-se de obter autorização da UA Europa antes de enviar inquéritos para esta região.',
    builderAudienceCustomTitle: 'Destinatários',
    builderAudienceCustomSubtitle: 'Defina quem receberá este inquérito personalizado.',
    builderRecipientsLabel: 'Destinatários',
    builderByMeetingId: 'Por Meeting ID',
    builderByPeople: 'Pessoas específicas',
    builderByOU: 'Por organograma (UA)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Pessoas',
    audienceTypeOU: 'UA',
    builderMeetingIdHint: 'Será aplicado a todos os participantes daquela sessão do Teams',
    builderSelectPeople: 'Selecione pessoas da lista',
    builderAllOUs: 'Todas as UAs',
    builderAllAvailableAdded: 'Todos os disponíveis já foram adicionados',
    builderSearchPeoplePlaceholder: 'Procurar pessoa pelo nome…',
    builderLoadingPeople: 'A carregar pessoas…',
    builderErrorLoadingPeople: 'Não foi possível carregar a lista de pessoas. Tente novamente.',
    builderPersonSelected: 'pessoa selecionada',
    builderPeopleSelected: 'pessoas selecionadas',
    builderSelectOU: 'Selecione uma UA...',
    builderSelectOUForTeam: 'Selecione uma UA para ver seus colaboradores',
    builderQuestionsTitle: 'Perguntas',
    builderEuropaQuestionsNote: 'Modo Europa: inquérito livre, sem vinculação a Fundamentals. Apenas perguntas sobre a reunião.',
    builderQuestionsApplyToAll: 'Cada pergunta se aplica a cada participante da reunião.',
    builderFilterAll: 'Todos',
    builderNoQuestions: 'Ainda não há perguntas',
    builderNoQuestionsHint: 'Clique em "+ Adicionar pergunta" para começar',
    builderNoQuestionsOfType: 'Sem perguntas deste tipo',
    builderAddQuestion: '+ Adicionar pergunta',
    builderQuestionLabel: 'Pergunta',
    builderDeleteQuestion: 'Eliminar',
    builderApproachLabel: 'Abordagem',
    builderIndividualSub: 'Avalia cada participante',
    builderCollectiveSub: 'Para a sessão em geral',
    builderPresentationMode: 'Modo de apresentação',
    builderMatrix: 'Matriz Geral',
    builderMatrixSub: 'Pergunta sobre a reunião ou tema geral',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'Um cartão por pessoa',
    builderTypeLabel: 'Tipo',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Selecione um Fundamental...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Selecione um Daily Habit...',
    builderQuestionText: 'Texto da pergunta',
    builderQuestionTextPlaceholder: 'Escreva a pergunta aqui',
    builderIconLabel: 'Ícone',
    builderOptional: '(opcional)',
    builderChangeIcon: 'Alterar',
    builderSelectIconBtn: 'Selecionar ícone',
    builderOptionsLabel: 'Opções (máx. 4 + "Não Observável")',
    builderNoObservable: 'Não Observável',
    builderRemoveNoObs: 'Remover Não Observável',
    builderAddNoObs: 'Adicionar "Não Observável"',
    builderAddOption: 'Adicionar Opção',
    builderMaxOptions: 'Máximo de 4 opções atingido',
    builderNPSInfo: 'NPS: escala de 0 a 10. Pergunta livre, sem atribuição a participantes.',
    builderOpenInfo: 'Espaço livre para o avaliador escrever sua resposta.',
    builderCampaignWeight: 'Peso de campanha',
    builderAdminGlobalOnly: 'Somente Admin Geral',
    builderCampaignWeightSub: 'Maior peso = maior prioridade quando há vários inquéritos ativos. Somente o Admin Geral pode modificá-lo.',
    builderWeightBase: 'Peso base (1–10)',
    builderWeightVeryLow: 'Muito Baixa',
    builderWeightLow: 'Baixa',
    builderWeightMedium: 'Média',
    builderWeightHigh: 'Alta',
    builderWeightVeryHigh: 'Muito Alta',
    builderBoostUrgent: 'Boost urgente',
    builderBoostUrgentSub: 'Eleva este inquérito acima de todos os outros temporariamente',
    builderBoostDays: 'dias',
    builderBoostActiveDays: 'dia',
    builderBoostActiveMsg: 'Boost ativo — este inquérito terá prioridade máxima por',
    builderNoBoostMsg: 'Sem boost ativo — prioridade conforme peso base',
    builderParticipantsTitle: 'Participantes a avaliar',
    builderParticipantsSub: 'Defina quantas pessoas são avaliadas por inquérito. Mínimo para anonimato e máximo para não sobrecarregar.',
    builderMinParticipantsLabel: 'Mínimo de participantes',
    builderMinParticipantsHint: 'Mín. para garantir anonimato',
    builderMaxParticipantsLabel: 'Máximo de participantes',
    builderMaxParticipantsHint: 'Máx. pessoas a avaliar por inquérito',
    builderPrivacyTitle: 'Privacidade e anonimato',
    builderPrivacySub: 'Defina se os feedbacks serão associados à identidade do respondente.',
    builderEnableAnonymity: 'Ativar anonimato',
    builderAnonymityDesc: 'Os feedbacks não incluirão o nome do utilizador — apenas a resposta e o horário',
    builderTranslationsTitle: 'Traduções',
    builderTranslationsEuropeSub: 'Audiência Europa — os 6 idiomas são obrigatórios. Use o toggle para ativar ou desativar um idioma.',
    builderTranslationsSub: 'A tradução para o Inglês é obrigatória como mínimo. Use o toggle para ativar idiomas adicionais.',
    builderAutoTranslateNote: 'As traduções são geradas automaticamente com o Azure Translator. Revise e ajuste cada campo conforme necessário.',
    builderLangNotApplicable: 'Não aplicável',
    builderLangComplete: 'Concluído',
    builderLangPending: 'Pendente',
    builderLangRequired: 'Obrigatório',
    builderLangOptional: 'Opcional',
    builderAutoTranslateBtn: 'Traduzir auto.',
    builderAutoTranslating: 'A traduzir…',
    builderAutoTranslateError: 'Não foi possível concluir a tradução automática. Tente novamente.',
    sessionExpiredError: 'A sessão expirou. Recarregue a página e inicie sessão novamente.',
    builderSourceLangLabel: 'Idioma de origem',
    builderSourceLangHint: 'Idioma em que está a redigir esta pergunta. Os demais idiomas serão pedidos como tradução na secção Traduções.',
    builderLangApplies: 'Aplica',
    builderLangDoesNotApply: 'Não aplica',
    builderTrlName: 'Nome:',
    builderTrlDesc: 'Descrição:',
    builderTrlEmpty: 'vazio',
    builderLangDisabled: 'Este idioma está desativado para este inquérito.',
    builderReviewTitle: 'Revisar e publicar',
    builderReviewTemplateTitle: 'Revisar modelo',
    builderEuropaPublishNote: 'Modo Europa: campanha independente por RGPD. Lembre-se de obter autorização da UA Europa.',
    builderPublishIdLabel: 'Identificador',
    builderPublishInternal: '(interno)',
    builderPublishTypeLabel: 'Tipo',
    builderPublishAudienceLabel: 'Audiência',
    builderPublishQuestionsLabel: 'Perguntas',
    builderPublishActiveDaysLabel: 'Dias ativos',
    builderPublishExpirationLabel: 'Expiração',
    builderPublishAnonymityLabel: 'Anonimato',
    builderPublishAnonymousVal: 'Anónimo',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Complete antes de publicar:',
    builderCompleteBeforeSave: 'Complete antes de guardar:',
    builderReadyToPublish: 'Tudo pronto. Clique em Publicar Inquérito para ativá-lo.',
    builderReadyToSaveTemplate: 'Tudo pronto. Clique em Guardar Modelo para o guardar.',
    builderIconCatalogTitle: 'Catálogo de ícones',
    builderSystemIcons: 'Ícones do sistema',
    builderNoIcon: 'Sem ícone',
    builderMyCatalog: 'Meu catálogo',
    builderDeleteFromCatalog: 'Eliminar do catálogo',
    builderCatalogEmpty: 'Seu catálogo está vazio — envie um ícone e guarde-o aqui',
    builderUploadIcon: 'Enviar novo ícone',
    builderIconNamePlaceholder: 'Nome do ícone (ex. Inovação)',
    builderSelectFile: 'Selecionar ficheiro',
    builderInvalidFormat: 'Formato inválido. Use SVG ou PNG com fundo transparente.',
    builderFileTooLarge: 'Ficheiro muito grande. Máximo 200 KB.',
    builderCustomIcon: 'Ícone personalizado',
    builderSaveForReuse: 'Guardar no catálogo para reutilizar',
    builderUseIcon: 'Usar ícone',
    builderIconHelp: 'SVG ou PNG, fundo transparente, 512×512 px recomendado, máx. 200 KB',
    builderPreviewCompleteStep1: 'Complete os dados do Passo 1 para ver a pré-visualização',
    builderPreviewClickToEdit: 'Clique em qualquer texto para editar',
    builderPreviewNoQuestions: 'As perguntas aparecerão aqui no Passo 3',
    builderPreviewGeneral: 'Geral',
    builderPreviewPersonalized: 'Personalizada',
    builderPreviewPulsoEspecifica: 'Pulso Específico',
    builderPreviewChangeIcon: 'Alterar ícone',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Coletivo',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'Matriz Geral',
    builderPreviewMissingTranslation: '(sem tradução)',
    builderPreviewWriteAnswer: 'Escreva sua resposta aqui...',
    builderPreviewNoObs: 'Não Observável',
    builderPreviewNA: 'N/A',
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Público',
    builderNavPreguntas: 'Perguntas',
    builderNavConfig: 'Configuração',
    builderNavPublicar: 'Publicar',
    builderNavGuardar: 'Guardar',
    builderInfoTitle: 'Informações básicas',
    builderSelectAll: 'Selecionar tudo',
    langEn: 'Inglês',
    langDe: 'Alemão',
    langPt: 'Português',
    langFr: 'Francês',
    langNl: 'Holandês',
    langRo: 'Romeno',
    builderTrlPlaceholderIn: 'em',
    builderTrlPlaceholderOpt: 'Opção',
    builderTrlNoText: 'Sem texto ainda',
    // New keys added during refactor
    builderLinkedTo: 'Vinculado a',
    builderSelectedIcon: 'Selecionado',
    builderHidePreview: 'Ocultar pré-visualização',
    builderShowPreview: 'Mostrar pré-visualização',
    builderPreviewMorePersons: 'pessoas mais',
    builderPreviewOption1: 'Opção 1',
    builderPreviewOption2: 'Opção 2',
    builderPreviewViewIn: 'Ver em:',
    builderFromOU: 'de',
    builderWillReceiveSurvey: 'receberão este inquérito',
    builderPersonsCount: 'pessoas',
    builderPersonsPlural: 'pessoas',
    builderPersonSingular: 'pessoa',
    builderInternalIdPlaceholder: 'Ex.: Fundamentos T1 2026',
    builderMeetingIdPlaceholder: 'Ex.: 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Opção',
    builderRemovePerson: 'Remover',
    builderSaveTemplateMock: 'Guardado como template ✓',
    builderPublishGlobalLabel: 'Global (excl. Europa)',
    builderTypeRating: 'Avaliação (1-4)',
    builderTypeMultiple: 'Múltipla Escolha',
    builderTypeOpen: 'Pergunta Aberta',
    builderTypeBehaviors: 'Comportamentos',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Sistema',
    // Monitor tab
    monitorTab: 'Monitorização',
    // Trace tab
    traceTab: 'Rastreabilidade',
    // Jobs tab
    jobsTab: 'Jobs',
    frontlineUsersTab: 'Gestão de utilizadores',
  },
  // Gestión de usuarios Frontline (Admin General): correos personales y verificación.
  frontlineUsers: {
    title: 'Gestão de utilizadores',
    subtitle: 'E-mails e verificação dos utilizadores. As contas que vêm do AD são só de leitura.',
    tableTitle: 'E-mails e palavras-passe',
    notice: 'As contas do AD são só de leitura: o e-mail corporativo vem do diretório. Nas restantes edita-se o e-mail pessoal, que a pessoa deve verificar para entrar e recuperar a palavra-passe.',
    search: 'Pesquisar por número de empregado, nome ou e-mail...',
    ouAll: 'OU: Todas',
    ouAllMine: 'OU: Todas as minhas OU',
    siteAll: 'Local: Todos',
    segment: 'Tipo de pessoal',
    segmentAll: 'Pessoal: Todos',
    segmentOption: { Staff: 'Staff', Frontline: 'Frontline' },
    stateAll: 'Verificação: Todas',
    hideInactive: 'Ocultar inativas',
    export: 'Exportar CSV',
    exporting: 'A exportar...',
    exportTruncated: 'O ficheiro ficou incompleto: atingiu-se o limite de linhas. Restrinja os filtros e exporte novamente.',
    exportError: 'Não foi possível exportar o ficheiro.',
    colPayroll: 'N.º de empregado',
    colName: 'Nome completo',
    colCorp: 'E-mail corporativo',
    colPersonal: 'E-mail pessoal',
    colOu: 'OU',
    colSite: 'Local',
    colStatus: 'Estado',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    colAction: 'Ação',
    colSend: 'Enviar verificação',
    colState: 'Verificação',
    chipVerified: '{{count}} verificados',
    chipPending: '{{count}} pendentes de verificação',
    chipNotSent: '{{count}} não enviados',
    chipNoEmail: '{{count}} sem registo',
    ssoRiskWarn: 'Esta ficha tem e-mail corporativo: se a pessoa entra por SSO, alterar o e-mail pode deixá-la sem acesso. Confirme antes de guardar.',
    chipDirectory: '{{count}} do AD',
    state: {
      Verificado: 'Verificado',
      Pendiente: 'Pendente de verificação',
      NoEnviado: 'Não enviado',
      SinCorreo: 'Sem registo',
      DelDirectorio: 'Do AD',
    },
    sentOn: 'Enviado {{date}}',
    send: 'Enviar',
    resend: 'Reenviar',
    noEmailTitle: 'Sem e-mail pessoal',
    verifiedTitle: 'O e-mail já está verificado',
    sendTitle: 'Enviar e-mail de verificação',
    sentOk: 'E-mail de verificação enviado para {{email}}.',
    empty: 'Não há utilizadores que correspondam à pesquisa.',
    editLabel: 'Editar {{name}}',
    verifLabel: 'Ver detalhe da verificação de {{name}}',
    editTitle: 'Editar utilizador — {{name}}',
    corpHelp: 'Só de leitura. Este e-mail é sincronizado a partir do SAP.',
    corpNone: 'Sem e-mail corporativo no SAP',
    corpLoginHelp: 'Só de leitura. Este é o e-mail com que a pessoa entra atualmente.',
    personalReplaceHelp: 'Deixe vazio para manter o e-mail de trabalho. Se a pessoa for entrar com outro e-mail, escreva-o aqui: substituirá o atual.',
    ssoAccessHelp: 'Esta pessoa entra com a sua conta corporativa (SSO): não se lhe adiciona um e-mail pessoal nem se envia ligação.',
    noLicenseTag: 'Sem licença',
    noLicenseCorp: 'Sem licença: deve registar-se',
    helpChange: 'Ao guardar, este e-mail terá de ser verificado novamente.',
    helpClear: 'Ao guardar, o utilizador ficará sem e-mail pessoal.',
    helpVerified: 'E-mail verificado.',
    helpDefault: 'É o e-mail com que a pessoa entra e recupera a palavra-passe.',
    saved: 'Alterações guardadas para {{name}}.',
    pw: {
      title: 'Palavra-passe',
      lastChange: 'Última alteração: {{date}}.',
      noRecord: 'Não consta quando alterou a palavra-passe.',
      tempPending: 'Tem uma palavra-passe temporária por usar; expira a {{date}}.',
      sendLink: 'Enviar ligação para o e-mail pessoal',
      sendActivation: 'Enviar ligação de ativação',
      unclaimedNote: 'Esta ficha ainda não tem conta: o caminho é a ligação de ativação (a mesma do registo). A palavra-passe temporária só se aplica a contas já reclamadas.',
      linkSent: 'Ligação enviada para {{email}}.',
      needsVerified: 'Disponível quando o e-mail pessoal estiver verificado.',
      needsEmail: 'Adicione um e-mail pessoal para enviar o link de ativação.',
      generate: 'Gerar palavra-passe temporária',
      forceChange: 'Pedir alteração da palavra-passe no próximo início de sessão',
      generateNote: 'A palavra-passe temporária não é enviada por e-mail: é mostrada uma só vez para que a entregues à pessoa.',
      expiryHint: 'A palavra-passe temporária caduca aos 7 dias; depois é preciso gerar outra.',
      confirmTitle: 'Gerar uma palavra-passe temporária?',
      confirmMsg: 'A palavra-passe atual desta pessoa deixará de funcionar de imediato e as ligações de reposição pendentes serão anuladas. A nova só é mostrada uma vez.',
      shownOnce: 'Só é mostrada desta vez. Entregue-a à pessoa antes de fechar esta janela.',
      expiresOn: 'Serve para entrar até {{date}}; depois é preciso gerar outra.',
      noExpiry: 'Não expira: é a palavra-passe que definiu para esta pessoa.',
      copy: 'Copiar',
      copied: 'Palavra-passe copiada.',
      copyFailed: 'Não foi possível copiar.',
    },
    err: {
      invalid: 'Escreva um e-mail válido, por exemplo nome@gmail.com.',
      taken: 'Esse e-mail já pertence a outra conta.',
      pending: 'A pessoa tem um registo por confirmar: não é possível alterar o e-mail até o confirmar ou se registar novamente.',
      required: 'Uma conta já registada não pode ficar sem e-mail.',
      notFound: 'A conta já não existe.',
      alreadyVerified: 'O e-mail já está verificado.',
      noEmail: 'A conta não tem e-mail pessoal.',
      inactive: 'A conta está desativada.',
      notClaimed: 'Esta conta ainda não se registou: ativa-se com o e-mail de ativação e não pode ser verificada manualmente.',
      notEligible: 'Esta conta não pode ser ativada neste momento.',
      quota: 'Foram enviados demasiados e-mails para esta conta. Aguarde um minuto e tente novamente.',
      sendFailed: 'Não foi possível enviar o e-mail agora. Tente novamente dentro de um minuto.',
      generic: 'Não foi possível concluir a ação.',
      emailNotVerified: 'O e-mail pessoal ainda não está verificado: verifique-o primeiro.',
      directory: 'Conta do AD (pessoal da empresa): o e-mail vem do diretório e não se edita nem se ativa aqui.',
      sso: 'Esta pessoa entra com a conta corporativa (SSO): não se ativa com e-mail e palavra-passe.',
      jobFunction: 'A função desta pessoa não está autorizada a registar-se com e-mail e palavra-passe.',
      ouBlocked: 'A OU desta pessoa não permite o registo por enquanto.',
      adminRecord: 'É uma ficha de administrador: não se regista por este meio.',
    },
    verTitle: 'Verificação — {{name}}',
    history: 'Histórico',
    noEvents: 'Sem movimentos',
    markVerified: 'Marcar como verificado',
    markTitle: 'Marcar como verificado?',
    markMsg: 'O e-mail será dado como verificado sem que a pessoa abra a ligação. Ficará registado em seu nome no histórico.',
    markedOk: '{{name}} ficou verificado.',
    markUnclaimedTitle: 'Esta conta ainda não se registou: ativa-se com o e-mail de ativação.',
    verResend: 'Reenviar verificação',
    eventBy: 'por {{name}}',
    event: {
      VerificacionEnviada: 'Verificação enviada',
      VerificacionReenviada: 'Verificação reenviada',
      CorreoVerificadoPorUsuario: 'E-mail verificado pela pessoa',
      CorreoActualizado: 'E-mail pessoal atualizado',
      VerificadoManualmente: 'Verificado manualmente por um administrador',
      EnlaceRestablecimientoEnviado: 'Ligação de reposição de palavra-passe enviada',
      PasswordTemporalGenerada: 'Palavra-passe temporária gerada',
    },
  },
  jobs: {
    title: 'Sincronização do cadastro',
    subtitle: 'De onde vêm os utilizadores e as unidades organizacionais, o catálogo de domínios corporativos e o estado de cada execução.',
    ouCatalogSync: 'Sincronização de OUs',
    userCatalogSync: 'Sincronização de Utilizadores',
    statusNeverRun: 'Nunca executado',
    statusRunning: 'A executar…',
    statusSuccess: 'Sucesso',
    statusSkipped: 'Ignorado',
    statusFailed: 'Erro',
    lastRun: 'Última execução',
    duration: 'Duração',
    triggerScheduled: 'Automático',
    triggerManual: 'Manual',
    created: 'Criados',
    updated: 'Atualizados',
    unchanged: 'Sem alterações',
    skipReason: 'Motivo',
    errorMessage: 'Erro',
    nextScheduled: 'Próxima execução automática',
    nextScheduledUnknown: 'Será calculada após a primeira execução',
    padronTitle: 'Registo',
    padronTotal: 'Fichas no total',
    padronUnclaimed: 'Não reivindicadas',
    padronLoading: 'A contar…',
    padronError: 'Não foi possível ler o registo.',
    padronHint: 'Uma ficha não reivindicada é uma pessoa do registo que ainda não entrou na plataforma. Não aparece nas listagens de administração.',
    identity: "Identidade de contadores",
    identityOk: "Fecha",
    identityBad: "NÃO fecha: {{suma}} vs {{recibidas}}",
    drift: "Desvio de contagem",
    duplicateEmail: "E-mails duplicados na origem",
    ouSubidaARaiz: "Fichas movidas para a sua unidade raiz",
    ouHuerfanaResuelta: "Unidades inexistentes resolvidas por região",
    ouHuerfanaSinResolver: "Unidades inválidas NÃO resolvidas",
    managerLinks: "Gestores resolvidos",
    licenseDiscarded: "Contas sem licença permitida",
    practicantesIncluded: "Estagiários incorporados",
    practicantesSinRegion: "Estagiários sem região (extensionAttribute12)",
    practicantesDeactivated: "Estagiários desativados",
    licenseDemotionCandidates: "Passariam a Frontline por licença",
    licenseDemoted: "Passados a Frontline por licença",
    runNow: 'Executar agora',
    runningDisabled: 'Já está em execução',
    viewHistory: 'Ver histórico',
    hideHistory: 'Ocultar histórico',
    historyEmpty: 'Ainda não há execuções registadas.',
    historyLoading: 'A carregar histórico…',
    historyError: 'Não foi possível carregar o histórico.',
    colDate: 'Data',
    colTrigger: 'Disparo',
    colStatus: 'Estado',
    colDuration: 'Duração',
    colDetail: 'Detalhe',
    triggerError: 'Não foi possível executar o job.',
    triggerConflict: 'O job já está em execução — aguarde terminar.',
    tabs: {
      users: 'Utilizadores',
      ous: 'Unidades organizacionais',
      domains: 'Domínios (Excel)',
      sentinels: 'Correios ignorados (SF)',
      delegation: 'Em nome de',
    },
    runsTitle: 'Execuções',
    noJobs: 'Não há execuções registadas nesta secção.',
    sfUserSync: 'Utilizadores (SuccessFactors)',
    sfOuSync: 'Unidades organizacionais (SuccessFactors)',
    adDomainSweep: 'Varrimento de domínios do diretório',
    cuentasBarridas: 'Contas ativas varridas',
    dominiosObservados: 'Domínios observados',
    dominiosNoDeclarados: 'Observados sem estarem declarados',
    dominiosDesaparecidos: 'Declarados que já não se observam',
    dominiosDesactivados: 'Domínios desativados',
    sync: {
      title: 'Fonte de dados',
      desc: 'De onde vem o cadastro de colaboradores.',
      users: 'Origem dos utilizadores',
      adOnly: 'Apenas Active Directory',
      adOnlyHint: 'Os colaboradores corporativos vêm do AD. O SuccessFactors continua a correr, mas apenas para quem não tem correio corporativo: não estão no AD e de outra forma nunca entrariam.',
      apiOnly: 'Apenas SuccessFactors',
      apiOnlyHint: 'Todo o cadastro vem do SuccessFactors, incluindo os corporativos. A execução do AD é omitida.',
      adThenApi: 'AD e depois SuccessFactors',
      adThenApiHint: 'Correm as duas. O SuccessFactors apenas preenche o que o AD deixou vazio; a única exceção é o país, que é sempre escrito pelo SuccessFactors.',
      ous: 'Unidades organizacionais',
      ousDesc: 'De onde vem a árvore de unidades organizacionais.',
      ouSource: 'Origem da árvore',
      ouAd: 'Active Directory',
      ouApi: 'SuccessFactors',
      sf: 'SuccessFactors',
      sfEnabled: 'Sincronização ativada',
      dryRun: 'Modo de simulação',
      dryRunHint: 'A execução conta tudo e comunica os resultados, mas NÃO escreve nenhuma alteração. É o modo recomendado para a primeira execução.',
      sfOn: 'Ativada',
      sfOff: 'Desligada',
      sfDryRun: 'Ativada, em simulação',
      sfManagedInUsers: 'Configura-se no separador Utilizadores: os mesmos interruptores governam as duas execuções.',
      domains: 'Domínios corporativos permitidos — carregamento por Excel',
      domainsDesc: 'Aplica-se APENAS ao carregamento em massa por Excel da Europa e dos EUA. Se adicionar um domínio, as pessoas do ficheiro com esse correio passam a entrar por SSO e deixam de se poder registar. Se retirar um, o correio é ignorado no carregamento e essas pessoas terão de declarar o seu ao registar-se. Não afeta a sincronização com o Active Directory nem com o SuccessFactors.',
      domainsHint: 'Um por linha, ou separados por vírgulas.',
      domainsCount: '{{n}} domínios',
      domainBadFormat: 'não parece um domínio (verifique espaços, arrobas ou caminhos)',
      domainDuplicate: 'repetido: será guardado apenas uma vez',
      domainsRemoved: 'Vão ser RETIRADOS',
      domainsRemovedWarning: 'As suas pessoas deixam de entrar por SSO e passam a poder registar-se com palavra-passe.',
      domainsAdded: 'Vão ser ADICIONADOS',
      domainsAddedWarning: 'As suas pessoas ficam obrigadas a entrar por SSO e não se podem registar.',
      domainsReview: 'Rever e guardar',
      domainsConfirm: 'Confirmar a alteração',
      domainsCancel: 'Cancelar',
      domainsAllInvalid: 'Nenhum domínio válido: não é possível guardar a lista vazia.',
      domainsSaved: 'Catálogo de domínios guardado.',
      saved: 'Configuração guardada.',
      loadError: 'Não foi possível ler a configuração das fontes.',
      updatedBy: 'Última alteração por',
      errSession: 'A sessão expirou. Volte a entrar e repita a alteração.',
      errForbidden: 'Não tem permissão para guardar esta configuração: é necessário o perfil AdminGlobal.',
      errValidation: 'A configuração não passou a validação: {{detalle}}',
      errValidationPlain: 'A configuração não passou a validação do servidor.',
      errOther: 'Não foi possível guardar (erro {{status}}). Se se repetir, é preciso consultar o registo do serviço.',
      errNetwork: 'Não foi possível guardar: não houve resposta do servidor. Verifique a ligação e tente de novo.',
      sentinels: 'Correios ignorados do SuccessFactors',
      sentinelsDesc: 'Aplica-se APENAS à sincronização com o SuccessFactors. É o texto que a origem coloca no campo de correio quando a pessoa NÃO tem correio. Não são endereços: compara-se apenas o que está antes da @, pelo que «nomail» cobre nomail@qualquer-domínio. Se retirar uma entrada, esse texto passa a ser guardado como um endereço real: quem o trouxer conta como corporativo, deixa de se poder registar, e a execução pode falhar por correio duplicado.',
      sentinelsHint: 'Um por linha. Pode colar endereços completos: guarda-se apenas a parte anterior à @.',
      sentinelsCount: '{{n}} entradas',
      sentinelBadFormat: 'não parece um nome de correio válido (verifique espaços ou caracteres estranhos)',
      sentinelNormalized: 'será guardado como «{{valor}}», pelo que cobrirá esse nome em QUALQUER domínio',
      sentinelsRemovedWarning: 'Esse texto volta a ser guardado como um endereço real. Se duas pessoas o partilharem, a execução falha por correio duplicado.',
      sentinelsAddedWarning: 'Quem trouxer esse texto passa a contar como «sem correio» e terá de se registar.',
      sentinelsSaved: 'Lista de correios ignorados guardada.',
      sentinelsEmpty: 'A lista não pode ficar vazia: sem nenhuma entrada, os correios marcadores da origem seriam guardados como endereços reais e a execução falharia.',
      delegation: '«Em nome de»: famílias excluídas',
      delegationDesc: 'Decide quem pode aparecer como emissor na caixa «Em representação de outra pessoa» e no carregamento em massa por CSV: apenas pessoal operacional da mesma unidade de quem a utiliza. As famílias de função desta lista não aparecem; quem não tem família só aparece se não tiver correio eletrónico corporativo. Os recetores não são limitados.',
      delegationEnabled: 'Aplicar a regra de «Em nome de»',
      delegationEnabledHint: 'Desligada, a caixa e o carregamento em massa funcionam como antes e a lista não tem efeito. A alteração aplica-se de imediato, sem implementação.',
      delegationHint: 'Códigos de família de função (SuccessFactors) excluídos, um por linha.',
      delegationCount: '{{n}} famílias excluídas',
      delegationBadFormat: 'não é um código de família: deve conter apenas dígitos (p. ex. 50000117)',
      delegationEmpty: 'Sem famílias excluídas, só se filtra pela unidade e quem não tem família e tem correio eletrónico corporativo.',
      delegationTurnOn: 'A regra vai ser ligada: a caixa e o carregamento em massa só aceitarão como emissor pessoal operacional da mesma unidade.',
      delegationTurnOff: 'A regra vai ser desligada: qualquer colaborador ativo voltará a poder ser escolhido como emissor.',
      delegationRemovedWarning: 'Essa família voltará a aparecer como emissor.',
      delegationAddedWarning: 'Essa família deixará de aparecer como emissor.',
      delegationSaved: 'Regra de «Em nome de» guardada.',
      adRules: 'Regras da sincronização do AD',
      adRulesDesc: 'Licença ativa, incorporação e desativação de estagiários, e passagem a Frontline por licença. As três primeiras começam desligadas e a quarta em «Só relatório»: ligam-se uma de cada vez, primeiro em «Só relatório» (conta quem seria afetado sem tocar em ninguém) e depois em «Aplicar».',
      adRulesSave: 'Guardar regras',
      adRulesConfirm: 'Confirmar e guardar',
      adRulesConfirmEnforce: 'Alguma regra está em «Aplicar»: decide quem entra ou sai do cadastro. Reveja os números do modo «Só relatório» antes de confirmar.',
      adRulesSaved: 'Regras guardadas.',
      modeOff: 'Desligada',
      modeOffHint: 'A regra não é aplicada.',
      modeReportOnly: 'Só relatório',
      modeReportOnlyHint: 'Conta quem seria afetado, sem tocar em ninguém. Os números aparecem no cartão da execução.',
      modeEnforce: 'Aplicar',
      modeEnforceHint: 'Aplica a regra. A licença e a desativação têm salvaguarda: se afetassem demasiadas contas, a execução não escreve a ninguém.',
      license: 'Licença ativa',
      licenseDesc: 'Só entram no cadastro as contas ativadas com uma das licenças permitidas (E3, E5, F3 ou F1). As contas fixas estão isentas.',
      licenseSkus: 'Licenças permitidas (SkuId)',
      licenseSkusHint: 'Um por linha. É o SkuId (um GUID) obtido com Get-MgSubscribedSku, não o nome.',
      licenseSkusCount: 'Licenças: {{n}}',
      licenseSkuBad: 'não é um SkuId válido (tem de ser um GUID, não o nome «E3»)',
      licenseSkusEmpty: 'Com a licença ligada, a lista não pode ficar vazia: indique quais as licenças (E3, E5, F3, F1) que contam.',
      licenseMax: 'Limite de descartados por licença (%)',
      licenseMaxHint: 'Se a licença deixasse de fora mais do que esta percentagem, a execução não escreve a ninguém: quase de certeza é uma lista de licenças mal escrita.',
      percentInvalid: 'Tem de ser um número inteiro entre 1 e 100.',
      practicantes: 'Incorporação de estagiários',
      practicantesDesc: 'Entra no cadastro quem tiver «PRACTICANTE» em extensionAttribute10 e a região em extensionAttribute12 (MEXICO, CENTRAL, FOSE ou LATAM). Sem região não entra: é contado e entra sozinho quando o dado existir.',
      deactivation: 'Desativação de estagiários',
      deactivationDesc: 'O estagiário ativo cujo cargo começa por «Practicante» e que já não aparece na sincronização (conta desativada, sem licença permitida ou sem «PRACTICANTE») é marcado como inativo. É eliminação lógica: a ficha não é apagada e não é reativada automaticamente.',
      deactivationNeedsInclusion: 'A desativação só corre com a incorporação de estagiários em «Aplicar». Enquanto não estiver, esta regra não faz nada.',
      deactivationMax: 'Limite de desativações (% de estagiários ativos)',
      deactivationMaxHint: 'Se a desativação atingisse mais do que esta percentagem, ninguém é desativado nessa execução: quase de certeza é um fluxo de dados truncado, não uma rotação normal.',
      demotion: 'Passagem a Frontline por licença',
      demotionDesc: 'Quem o diretório deixa de fora por não ter licença e o SuccessFactors continua a enviar fica marcado como «sem licença»; o SuccessFactors passa-o a Frontline e esvazia o seu email corporativo. As fichas já reclamadas também são convertidas (a palavra-passe é apagada), exceto as de administrador. Se a licença voltar, a marca é removida automaticamente.',
      demotionNeedsLicense: 'Esta regra só atua com a licença ativa em «Aplicar». Enquanto não estiver, não fará nada.',
      demotionMax: 'Limite de conversões (%)',
      demotionMaxHint: 'Se a conversão atingisse mais do que esta percentagem das pessoas do diretório com SuccessFactors, ninguém é convertido nessa execução: quase de certeza é uma lista de licenças mal escrita.',
    },
  },
  monitor: {
    title: 'Monitor de Pipeline',
    subtitle: 'Auditoria de elegibilidade por reunião: regras avaliadas, participantes excluídos e amostragem aplicada.',
    refresh: 'Atualizar',
    loading: 'A carregar eventos…',
    lastFetch: 'Atualizado',
    timeout: 'Timeout (10s) — MeetingService não respondeu.',
    unknownError: 'Erro desconhecido',
    empty: 'Sem eventos de pipeline. Processe ou simule uma reunião para ver os registos.',
    eligible: 'Elegível',
    ineligible: 'Não elegível',
    excluded: 'Excluído',
    sampled: 'Amostrado',
    samplingApplied: 'Amostragem aplicada',
    noParticipants: 'Sem detalhes de participantes.',
    statTotal: 'Reuniões processadas',
    statEligible: 'Reuniões elegíveis',
    statAvgSampled: 'Média amostrada',
    statAvgSampledSub: 'por reunião elegível',
    statSampling: 'Amostragem aplicada',
    statSamplingSub: 'reuniões com maxPax ativo',
    colMeetingId: 'ID Reunião',
    colDate: 'Data',
    colDuration: 'Duração',
    colEvaluated: 'Avaliados',
    colEligible: 'Elegíveis',
    colSampled: 'Amostrados',
    colMaxPax: 'Amostragem',
    colResult: 'Resultado',
    colUserId: 'Utilizador',
    colOu: 'OU',
    colTimezone: 'Fuso Horário',
    colToday: 'Hoje',
    colWeek: 'Semana',
    colInterval: 'Intervalo',
    colStatus: 'Estado',
    colReason: 'Motivo',
    colSample: 'Inquérito',
    instancesTitle: 'Inquéritos atribuídos',
    instancesBtnTitle: 'Ver inquéritos deste participante',
    instancesLoading: 'A carregar inquéritos…',
    instancesEmpty: 'Sem instâncias de inquérito para este participante nesta reunião.',
    instancesSurvey: 'Inquérito',
    instancesStatus: 'Estado',
    instancesExpires: 'Expira',
    instancesDownload: 'Transferir JSON',
    instancesClose: 'Fechar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    recalculate: 'Recalcular respostas',
    recalculateTitle: 'Recalcular contagem de respostas em todos os inquéritos',
    recalculateSuccess: 'Recálculo concluído: {{count}} inquérito(s) atualizado(s).',
    recalculateError: 'Erro ao recalcular respostas.',
    cacheTitle: 'Cache do catálogo de OUs',
    cacheLoading: 'A consultar cache…',
    cacheError: 'Não foi possível obter o estado do cache de OUs.',
    cachePopulated: 'Preenchido',
    cacheNotPopulated: 'Não preenchido',
    cacheOuCount: 'OUs em cache',
    cacheLastSynced: 'Última sincronização',
    cacheNeverSynced: 'Nunca sincronizado',
  },
  trace: {
    title: 'Rastreabilidade do pipeline',
    subtitle: 'Trajetória completa de uma reunião, do encerramento da chamada ao envio da notificação.',
    filterModeLabel: 'Pesquisar por',
    filterModeSubject: 'Nome da reunião',
    filterModeEmail: 'E-mail',
    filterPlaceholderSubject: 'Ex.: Daily da plataforma',
    filterPlaceholderEmail: 'Ex.: nome.sobrenome@sigma.com',
    search: 'Pesquisar',
    searching: 'A pesquisar…',
    clear: 'Limpar',
    initialHint: 'Escolha um modo de busca e introduza um termo para ver a rastreabilidade.',
    invalidEmail: 'Introduza um e-mail válido.',
    requestError: 'Não foi possível obter a rastreabilidade. Tente novamente.',
    retry: 'Tentar novamente',
    download: 'Transferir rastro (JSON)',
    notFoundEmailNotRegistered: 'Esse e-mail não está registado como utilizador. Verifique a sincronização com o Azure AD.',
    notFoundUserWithoutMeetings: 'O utilizador existe, mas não participou em nenhuma reunião registada.',
    notFoundSubjectNoMatches: 'Nenhuma reunião corresponde a esse nome.',
    notFoundMeetingNotFound: 'Essa reunião não existe mais.',
    notFoundUserDirectoryUnavailable: 'Não foi possível consultar o diretório de utilizadores. Verifique se o UserAdminService está disponível.',
    matchesTitle: 'Várias reuniões correspondem — escolha uma',
    matchesSubject: 'Reunião',
    matchesOrganizer: 'Organizador',
    matchesStatus: 'Estado',
    matchesStarted: 'Início',
    matchesEnded: 'Fim',
    meetingSummary: 'Reunião',
    meetingCorrelation: 'CorrelationId',
    meetingDuration: 'Duração',
    meetingStatus: 'Estado',
    warningsTitle: 'Avisos',
    stagesTitle: 'Etapas do pipeline',
    stageColOrder: '#',
    stageColName: 'Etapa',
    stageColService: 'Serviço',
    stageColTime: 'Hora',
    stageColOutcome: 'Resultado',
    stageMeetingEnd: 'Fim da reunião',
    stageMeetingEligibility: 'Elegibilidade da reunião',
    stageParticipantEligibility: 'Elegibilidade dos participantes',
    stageSurveyCreation: 'Criação de inquéritos',
    stageNotification: 'Notificações',
    outcomeOk: 'OK',
    outcomeError: 'Erro',
    outcomeNotEligible: 'Não elegível',
    outcomeNoData: 'Sem dados',
    logsTitle: 'Log bruto correlacionado',
    logsSubtitle: 'Entradas do MeetingService, SurveyService, AnalyticsService e Bot. O NotificationService não armazena log bruto.',
    logsEmpty: 'Sem entradas de log para esta reunião. O TTL de app_logs é de 24 horas.',
    logsFilterAll: 'Todos',
    logsFilterWarning: 'Warning e superior',
    logsFilterError: 'Somente erros',
    logsColTime: 'Hora',
    logsColService: 'Serviço',
    logsColLevel: 'Nível',
    logsColMessage: 'Mensagem',
  },
  system: {
    title: 'Diagnóstico do Sistema',
    subtitle: 'Estado em tempo real de todos os microsserviços e workers do backend.',
    refreshAll: 'Atualizar tudo',
    refresh: 'Atualizar',
    lastChecked: 'Última verificação',
    checking: 'A verificar…',
    never: 'Nunca',
    statusHealthy: 'Saudável',
    statusDegraded: 'Degradado',
    statusError: 'Erro de ligação',
    showDetails: 'Ver verificações',
    hideDetails: 'Ocultar verificações',
    legendTitle: 'Glossário de estados',
    legendHealthyDesc: 'Todas as verificações internas do serviço responderam corretamente.',
    legendDegradedDesc: 'O serviço responde mas MongoDB, Redis ou Service Bus reportaram erro.',
    legendErrorDesc: 'Não foi possível alcançar o serviço a partir do frontend (timeout, CORS ou serviço inativo).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Assinaturas',
    activeMessages: 'Mensagens ativas',
    deadLetterMessages: 'Dead Letter',
    environment: 'Ambiente',
    version: 'Versão',
    workers: 'Workers',
    workersDesc: 'Estado inferido a partir das assinaturas do Service Bus.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Sem estatísticas de assinatura disponíveis.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Erro',
  },
  analytics: {
    title: 'Painel Executivo',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Vieses',
    omissions: 'Omissões',
    personal: 'Pessoal',
    score: 'Pontuação',
    responses: 'Respostas',
    participants: 'Participantes',
    period: 'Período',
    ou: 'Unidade Organizacional',
    noData: 'Dados insuficientes',
    completionRate: 'Taxa de conclusão',
    avgByCategory: 'Média por categoria',
    organization: 'Organização',
    fundamentalsRadar: 'Radar de fundamentos',
    heatmapOuFund: 'Mapa de calor — Pontuação por unidade organizacional e fundamental',
    moduleInDev: 'Módulo em desenvolvimento',
    executiveSubtitle: 'visão executiva',
    exec: {
      periodAll: 'Todo o histórico',
    },
    tabs: { summary: 'Resumo', fundamentals: 'Fundamentos', heatmap: 'Mapa de Calor', orgNetwork: 'Rede Organizacional', generational: 'Geracional' },
    noScopeTitle: 'Sem unidades organizacionais atribuídas',
    noScopeDesc: 'Sua conta não tem unidades organizacionais atribuídas, portanto não há relatórios para exibir. Peça ao administrador central que configure seu escopo.',
    filterBar: { allOrg: 'Toda a organização', allMyScope: 'Todo o meu escopo', allBU: 'Todas as BUs', allDept: 'Todos os Deptos', dateFrom: 'De', dateTo: 'Até', allDimensions: 'Todos os comportamentos', clearFilters: 'Limpar filtros' },
    dimensionFilter: {
      partialScope: 'Filtrado por «{{dimension}}». A taxa de resposta, os avaliadores, os inquéritos por dia e as omissões não são detalhados por comportamento: correspondem a todo o escopo.',
      notApplicable: 'Este bloco não é detalhado por comportamento: é exibido sem o filtro «{{dimension}}».',
    },
    kpi: { evaluations: 'Avaliações', avgScore: 'Pontuação Média', responseRate: 'Taxa de Resposta', avgPerDay: 'Média / Dia', evaluators: 'Avaliadores', scale: 'escala 1–4', noObservables: 'não observáveis', perDay: 'inquéritos por dia', activeParticipants: 'participantes ativos', ofTotal: 'totais', evaluatedPeople_one: '{{count}} pessoa avaliada', evaluatedPeople_other: '{{count}} pessoas avaliadas', responseRateSub: 'dos inquéritos já encerrados' },
    summary: { topBehaviors: 'Top Daily Habits', topDailyHabitsSubtitle: 'Hábitos com maior impacto cultural', oppSubtitle: 'Hábitos com mais espaço de melhoria', opportunities: 'Áreas de Oportunidade', omissionsByUnit: 'Omissões por Unidade', omissionsSubtitle: 'Taxa de omissão por UO e BU — ordenadas da maior para a menor · Clique em uma UO para ver suas BUs', downloadExcel: 'Transferir Excel', omitType: 'Tipo', omitPeople: 'Pessoas', omitRate: 'Taxa de Omissão', noOmissions: 'Sem omissões significativas', percentileDistribution: 'Distribuição por Percentil', percentileSubtitle: 'Percentual da população em cada faixa de pontuação', personsEvaluated: 'pessoas avaliadas', excellent: 'Excelente', good: 'Bom', developing: 'Em desenvolvimento', attention: 'Atenção', fundPositioning: 'Posicionamento Fundamentos', fundPositioningDesc: 'Ranking, maior/menor pontuação e taxa de não observável por fundamental', highestScore: 'Maior pontuação', lowestScore: 'Menor pontuação', mostNoObs: 'Mais Não Observável', scoreByOU: 'Pontuação por Unidade Organizacional', scoreByOUSubtitle: 'Clique em uma UO para ver o detalhamento por BU e Departamento', person: 'pessoa', persons: 'pessoas', evaluationsCount_one: '{{count}} avaliação', evaluationsCount_other: '{{count}} avaliações', behaviorPositioningDesc: 'Ranking por comportamento; os fundamentais sem comportamentos configurados aparecem inteiros', behaviorColumn: 'Comportamento', distribution: 'Distribuição', omittedSurveys: 'Omitidos' },
    fundamentals: { title: 'Score por Fundamental', subtitle: 'Expanda cada fundamental para ver seus daily habits e detalhes por OU', evalLabel: 'aval', confPreliminary: 'Dado preliminar', confBasedOn: 'Baseado em {{n}} aval', behaviorSubtitle: 'Cada fundamental se desdobra em seus comportamentos; expanda um para ver seus daily habits', noObsCount_one: '{{count}} inquérito não o avaliou', noObsCount_other: '{{count}} inquéritos não o avaliaram', dailyHabits: 'Daily habits' },
    heatmap: { title: 'Mapa de Calor Cultural', subtitle: 'Toque em qualquer linha para explorar suas sub-unidades', unit: 'Unidade', unitOU: 'Unidade Organizacional', unitBU: 'Business Unit', unitDept: 'Departamento', unitPerson: 'Responsável', allOrg: 'Toda a organização', hint: 'Toque qualquer linha para explorar o próximo nível →', person: 'pessoa', persons: 'pessoas', legendCritical: 'Crítico', legendLow: 'Baixo', legendMedium: 'Médio', legendGood: 'Bom', legendExcellent: 'Excelente', noOu: 'Sem UO', behaviorSubtitle: 'Pontuação por unidade organizacional e comportamento; toque em qualquer linha para explorar suas subunidades', directlyAssigned: 'Atribuídos a {{ou}}', hideEmpty_one: 'Ocultar {{count}} unidade sem dados', hideEmpty_other: 'Ocultar {{count}} unidades sem dados', personCount_one: '{{count}} pessoa', personCount_other: '{{count}} pessoas' },
    ona: { title: 'Rede Organizacional (ONA)', subtitle: 'Árvore interativa das unidades organizacionais (OU)', treeHint: 'Expanda cada nó para navegar pelos níveis de OU da organização.', omissions: 'Omissões', totalPeople: 'Pessoas', avgScore: 'Pontuação média', totalEvals: 'Total de avaliações', collaboratorsKpi: 'Colaboradores', highestOmission: 'Maior omissão', omissionsRanking: 'Ranking de omissões', maturityCulture: 'Maturidade cultural', maturityLegend: 'Legenda de maturidade', maturityInitial: 'Inicial', maturityGrowing: 'Em desenvolvimento', maturityConsolidated: 'Consolidado', maturityRoleModel: 'Modelo de referência', evalsLabel: 'avaliações', noEvals: 'Sem avaliações', collaboratorsLabel: 'colaboradores', omissionLabel: 'omissão', evalsShort: 'avals', omittedCount_one: '{{count}} omitida', omittedCount_other: '{{count}} omitidas', directlyAssigned: 'Atribuídos diretamente', collaboratorsCount_one: '{{count}} colaborador', collaboratorsCount_other: '{{count}} colaboradores', typeBu: 'BU', typeDept: 'Depto.', typePerson: 'Pessoa' },
    gen: { panorama: 'Panorama', ranking: 'Ranking', brechas: 'Lacunas', avgAge: 'Idade média', title: 'Análise Geracional', subtitle: 'Distribuição e maturidade cultural por coorte · {{n}} pessoas mapeadas', noRepresentation: 'Sem representação', scoreLabel: 'Score', omissionLabel: 'Omissão', personas: 'pessoas', age: 'Idade', all: 'Todos', noData: 'Sem dados para este filtro', fundamental: 'Fundamental', gapCol: 'Δ Lacuna', brechaNote: 'Maior lacuna: {{fund}} · Δ {{delta}} pts entre gerações', brechaSource: 'Diferença em relação à média geral do fundamental na organização', responseCount: '{{n}} respostas', personasCount_one: '{{count}} pessoa', personasCount_other: '{{count}} pessoas' },
  },
  userConfig: {
    fabTitle: 'Configurar perfil de utilizador',
    title: 'Perfil de utilizador (demo)',
    subtitle: 'Modo de teste — simula os dados que virão do Teams SSO na integração com o back-end',
    nombre: 'Nome',
    correo: 'E-mail',
    ou: 'OU (Unidade Organizacional)',
    do_: 'DO (Divisão)',
    bu: 'BU (Unidade de Negócios)',
    departamento: 'Departamento',
    puesto: 'Cargo',
    numeronomina: 'Número de matrícula',
    role: 'Perfil',
    roleDetected: 'Perfil detectado',
    roleNotFound: 'E-mail não encontrado — será usado Funcionário',
    save: 'Guardar perfil',
    namePlaceholder: 'Ex.: Ana García',
    emailPlaceholder: 'Ex.: agarcia@sigma.com',
    ouPlaceholder: 'Ex.: Tecnologia',
    doPlaceholder: 'Ex.: Diretoria de TI',
    buPlaceholder: 'Ex.: Portugal',
    deptPlaceholder: 'Ex.: Desenvolvimento de Software',
    puestoPlaceholder: 'Ex.: Engenheiro de Software Sr.',
    nominaPlaceholder: 'Ex.: 123456',
    fechaNacimiento: 'Data de nascimento',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Ocorreu um erro inesperado',
    unauthorized: 'Não tem permissão para esta ação',
    notFound: 'Recurso não encontrado',
    network: 'Erro de ligação. Verifique sua rede.',
  },
  fundamentals: {
    title: 'Fundamentos',
    subtitle: 'Os comportamentos que medimos na Sigma. Abra um para ver seus hábitos diários.',
    habitsFor: 'Hábitos diários',
    otherHabits: 'Outros hábitos',
    openHabits: 'Ver hábitos diários de {{name}}',
    openMicrosite: 'Abrir o microsite de {{name}}',
  },
};

export default pt;
